import { render, staticRenderFns } from "./PurchaseClubInsurance.vue?vue&type=template&id=152e0b1b"
import script from "./PurchaseClubInsurance.vue?vue&type=script&lang=js"
export * from "./PurchaseClubInsurance.vue?vue&type=script&lang=js"
import style0 from "./PurchaseClubInsurance.vue?vue&type=style&index=0&id=152e0b1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports